import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Rides from "@/pages/Rides";
import AuthCallback from "@/pages/AuthCallback";
import PublicRoute from "@/pages/PublicRoute";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-brema-yellow font-mono text-xs uppercase tracking-widest">
        Loading Roadbook…
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Handle session_id in URL fragment before routing kicks in
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/r/:shareId" element={<PublicRoute />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rides"
        element={
          <ProtectedRoute>
            <Rides />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App dark brema-grain">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster
              theme="dark"
              position="top-right"
              toastOptions={{
                style: {
                  background: "#1D2433",
                  color: "#F8F9FA",
                  border: "1px solid #28304A",
                  borderRadius: "2px",
                  fontFamily: "JetBrains Mono, monospace",
                  fontSize: "12px",
                },
              }}
            />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}
